function removeUndefined<T>(array: (T | undefined)[]): T[] {
    return array.filter(item => item !== undefined) as T[];
}

function removeNull<T>(array: (T | null)[]): T[] {
    return array.filter(item => item !== null) as T[];
}

function removeNullish<T>(array: (T | null | undefined)[]): T[] {
    return array.filter(item => item !== null && item !== undefined) as T[];
}

function removeFalsy<T>(array: (T | null | undefined | false | 0 | '')[]): T[] {
    return array.filter(item => item) as T[];
}

function joinClassNames(...classNames: (string | null | undefined | false | 0 | '')[]): string {
    return classNames.filter(item => item !== null && item !== undefined).join(' ');
}

export { removeUndefined, removeNull, removeNullish, removeFalsy, joinClassNames };
